import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormFieldTextComponent } from '../form-field-text.component';

@Component({
    selector: 'lib-input-text-search',
    templateUrl: './form-field-text-search.component.html',
    styleUrls: ['./form-field-text-search.component.scss']
})
export class FormFieldTextSearchComponent extends FormFieldTextComponent implements OnInit {
    @Output() searchClicked: EventEmitter<void> = new EventEmitter();
    @Output() clearClicked: EventEmitter<void> = new EventEmitter();

    override readonly hasPrefixIconButton: boolean = true;
    override readonly hasSuffixIconButton: boolean = true;

    constructor() {
        super();
        this.isOptional = false; // NOT show "Optional" by default
    }

    SearchIconClicked(): void {
        this.searchClicked.emit();
    }

    ClearIconClicked(): void {
        this.viewControl.setValue('');
        this.clearClicked.emit();
        this.SearchIconClicked(); // after clearing the search text, do a search to have the default display items
    }

    @HostListener('keydown.enter', ['$event'])
    Search(event: KeyboardEvent) {
        this.SearchIconClicked();
    }
}
